import { Container } from './NotFound.styles';
import { LinkButton } from '@/components/Button/Button';
import { Seo } from '@/components/Seo';
import { SEO_DATA } from '@/utils/seoConstants/blog-page';

const notFound = `404 - Page Not Found`;

const NotFound = () => (
  <>
    <Container>
      <h1>{notFound}</h1>
      <LinkButton href="/blog">Go back to blog</LinkButton>
    </Container>
    <Seo {...SEO_DATA} customTitle={notFound} />
  </>
);

export default NotFound;
